/**
 * Meal type presentation config — icon and colours.
 *
 * Lives in its own module so both the card and its tests read ONE definition.
 * The test file used to keep a private copy, which meant the UI could change
 * colour without a single assertion failing. It also keeps MealTimelineCard.jsx
 * exporting only its component, which react-refresh requires.
 *
 * The four hues must stay far apart on the colour wheel. Breakfast and Lunch
 * were amber-300 and yellow-300 — neighbouring hues that render as the same
 * warm orange on the dark surface. Reported from production, where a day of one
 * breakfast and five lunches looked like six identical cards. Lunch is now rose,
 * clear of amber (~45 deg), indigo (~245 deg) and green (~140 deg).
 */
export const MEAL_CONFIG = {
  BREAKFAST: { icon: '🌅', color: 'text-amber-600', bgColor: 'bg-amber-50', borderColor: 'border-amber-300' },
  LUNCH: { icon: '🌞', color: 'text-rose-600', bgColor: 'bg-rose-50', borderColor: 'border-rose-300' },
  DINNER: { icon: '🌙', color: 'text-indigo-600', bgColor: 'bg-indigo-50', borderColor: 'border-indigo-300' },
  SNACK: { icon: '🍎', color: 'text-green-600', bgColor: 'bg-green-50', borderColor: 'border-green-300' }
}
